module.exports = __webpack_public_path__ + "img/no_internet.79e540f6.svg";